// API
import { ApiProduct } from './products';

const baseUrl = 'events';

export const ApiEvent = {
  GetEventByProduct: (id: string) => `${ApiProduct.GetProductDetail(id)}/${baseUrl}`
};
